import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { errorToast } from "components/toast";
import { successToast } from "components/toast";
import { Formik } from "formik";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Form,
  Navbar,
  Nav,
  Container,
  Media,
  Button,
} from "reactstrap";
import { updateLoginUserPassword } from "services/_user";
import { getLoginUserDetails } from "services/_user";
import * as Yup from "yup";
import { getMe } from "context/AuthContext";

const AdminNavbar = (props) => {
  const [UserData, setUserData] = useState({});
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();
  const me = getMe();
  const isOrgUser = me?.partner !== "DEFAULT";

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("me");
    navigate("/auth/login");
  };

  const initialData = async () => {
    const data = await getLoginUserDetails();
    if (data.isSuccess) {
      setUserData(data.data);
    }
  };

  useEffect(() => {
    initialData();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = async (values) => {
    const data = await updateLoginUserPassword(values);
    if (data.isSuccess) {
      successToast(data.message);
      setOpen(false);
    } else {
      errorToast(data.message);
    }
  };

  const validationSchema = Yup.object().shape({
    newPassword: Yup.string()
      .required("New Password is required")
      .matches(
        /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/,
        "Password must be at least 8 characters, include 1 uppercase letter, 1 number, and 1 special character"
      ),
    oldPassword: Yup.string().required("Old Password is required"),
  });

  return (
    <>
      <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
        <Container fluid>
          <Link
            to="/"
            className="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block"
          >
            {/* {props.brandText} */}
          </Link>
          <Nav className="align-items-center d-none d-md-flex" navbar>
            <UncontrolledDropdown nav>
              <DropdownToggle className="pr-0" nav>
                <Media className="align-items-center">
                  <span className="avatar avatar-sm rounded-circle">
                    <i className="fa fa-user text-gray-800"></i>
                  </span>
                  <Media className="ml-2 d-none d-lg-block">
                    <span className="mb-0 text-sm font-weight-bold">
                      {UserData.name}
                    </span>
                  </Media>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Welcome!</h6>
                </DropdownItem>
                {!isOrgUser && (
                  <DropdownItem to="/admin/user-profile" tag={Link}>
                    <i className="ni ni-single-02" />
                    <span>My profile</span>
                  </DropdownItem>
                )}
                {!isOrgUser && (
                  <DropdownItem to="/admin/setting" tag={Link}>
                    <i className="ni ni-settings-gear-65" />
                    <span>Settings</span>
                  </DropdownItem>
                )}
                {!isOrgUser && (
                  <DropdownItem onClick={() => setOpen(true)}>
                    <i className="ni ni-lock-circle-open" />
                    <span>Update Password</span>
                  </DropdownItem>
                )}
                <DropdownItem divider />
                <DropdownItem href="#pablo" onClick={(e) => e.preventDefault()}>
                  <i className="ni ni-user-run" />
                  <span onClick={handleLogout}>Logout</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Container>
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
          <DialogTitle>Update Password</DialogTitle>
          <Formik
            initialValues={{ newPassword: "", oldPassword: "" }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              values,
              errors,
              handleChange,
              handleBlur,
              touched,
              handleSubmit,
              isSubmitting,
            }) => (
              <Form onSubmit={handleSubmit} id="subscription-form">
                <DialogContent>
                  <TextField
                    required
                    margin="dense"
                    id="oldPassword"
                    name="oldPassword"
                    label="Old Password"
                    type="password"
                    fullWidth
                    variant="standard"
                    value={values.oldPassword}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.oldPassword && Boolean(errors.oldPassword)}
                    helperText={touched.oldPassword && errors.oldPassword}
                  />
                  <TextField
                    required
                    margin="dense"
                    id="newPassword"
                    name="newPassword"
                    label="New Password"
                    type="password"
                    fullWidth
                    variant="standard"
                    value={values.newPassword}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.newPassword && Boolean(errors.newPassword)}
                    helperText={touched.newPassword && errors.newPassword}
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={handleClose}
                    style={{
                      width: "100%",
                      backgroundColor: "red",
                      color: "white",
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    style={{
                      width: "100%",
                      color: "white",
                      backgroundColor: "green",
                    }}
                  >
                    Save
                  </Button>
                </DialogActions>
              </Form>
            )}
          </Formik>
        </Dialog>
      </Navbar>
    </>
  );
};

export default AdminNavbar;
